import Index from '@/views/index'
import jdyrole from '@/common/jdyrole';
export const service = {
    path: '/service',
    redirect: '/service/project/projectlist',
    component: Index,
    name: 'service',
    subNav: true,
    meta: {
        title: '筋斗云-项目管理',
        requiresAuth: false,
        requiresRole: [jdyrole.superadmin, jdyrole.projectmanager, jdyrole.projectread, jdyrole.projectreadteam]
    },
    children: [{
        path: '/service/project/projectlist',
        components: { default: () => import('@/views/service/project-list/')},
        name: 'projectList',
        meta: {
            title: '筋斗云-项目管理',
            requiresAuth: true,
            requiresRole: [jdyrole.superadmin, jdyrole.projectmanager, jdyrole.projectread, jdyrole.projectreadteam]
        }
    }, {
        path: '/service/project/projectDetails',
        components: {
            default: () => import('@/views/service/project-details/project-details/')
        },
        name: 'projectDetails',
        meta: {
            title: '筋斗云-项目详情',
            requiresAuth: true,
            requiresRole: [jdyrole.superadmin, jdyrole.projectmanager, jdyrole.projectread, jdyrole.projectreadteam]
        }
    }, {
        path: '/service/project/projectDemand',
        components: {
            default: () => import('@/views/service/project-demand/index')
        },
        name: 'projectDemand',
        meta: {
            title: '筋斗云-网站需求',
            requiresAuth: false,
            requiresRole: [jdyrole.superadmin, jdyrole.projectmanager, jdyrole.projectread, jdyrole.projectreadteam]
        }
    }, {
        path: '/service/project/projectSet',
        components: {
            default: () => import('@/views/service/project-set/')
        },
        name: 'projectSet',
        meta: {
            title: '筋斗云-项目设置',
            requiresAuth: true,
            requiresRole: [jdyrole.superadmin, jdyrole.projectmanager]
        }
    }, {
        path: '/service/project/LineUp',
        components: {
            default: () => import('@/views/service/project-lineup/')
        },
        name: 'lineUp',
        meta: {
            title: '筋斗云-排队情况',
            requiresAuth: true,
            requiresRole: [jdyrole.superadmin, jdyrole.projectmanager]
        }
    }, {
        path: '/service/project/project-details/projectEvaluation',
        components: {
            default: () => import('@/views/service/project-details/project-evaluation')
        },
        name: 'projectEvaluation',
        meta: {
            title: '筋斗云-评价详情',
            requiresAuth: true,
            requiresRole: [jdyrole.superadmin, jdyrole.projectmanager, jdyrole.projectread, jdyrole.projectreadteam]
        }
    }, {
        path: '/service/project/project-details/projectLog',
        components: {
            default: () => import('@/views/service/project-details/project-log')
        },
        name: 'projectLog',
        meta: {
            title: '筋斗云-项目日志',
            requiresAuth: true,
            requiresRole: [jdyrole.superadmin, jdyrole.projectmanager, jdyrole.projectread, jdyrole.projectreadteam]
        }
    }]
}




// WEBPACK FOOTER //
// ./src/router/service/index.js